export class WarrantyCard{
    id: number;
    code: string;
    isUsed: boolean;
    prePairedProductItemId: number;
    prePairedSerialNumber: string;
    createdOn: Date
}